import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BnLoadingService, EntityPagedResult} from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { Estado } from "src/app/model/estado.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import {
  ROLE_AGENTE_CONSULTA,
  ROLE_AGENTE_ENVIO,
  ROLE_GESTOR_CONSULTA,
} from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import Utils from "src/app/shared/fgi-utils";
import { DatePipe } from "@angular/common";
import { DetalheLeilaoService } from "../detalhe-leilao.service";
import { DetalheLeilao } from "src/app/model/leilao.model";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { MensagemService } from "../../mensagem.service";

@Component({
  selector: "app-consulta-status-leilao",
  templateUrl: "./consulta-status-leilao.component.html",
  styleUrls: ["./consulta-status-leilao.component.scss"],
  standalone: false
})
export class ConsultaStatusLeilaoComponent implements OnInit {
  pesquisaForm: FormGroup;
  private parametrosPesquisa: any = {};
  atributosPaginacaoComponenteListagem: EntityPagedResult<DetalheLeilao>;
  agenteFinanceiroLogado: AgenteFinanceiro;

  podeEscolherAgente: boolean = false;
  podeEnviarArquivo: boolean = false;
  podeEnviarRecCredito: boolean;
  cnpjUsuario: string;
  private totalObjetosRetornados: number;
  private ehAgenteFinanceiro = false;
  pesquisado: boolean = false;
  esconderPesquisa: boolean = true;

  estados: Estado[] = [];
  public detalhesLeilao: DetalheLeilao[];
  agentesFinanceiros: AgenteFinanceiro[];
  private opcoesPaginacao: number[];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private readonly loadingService: BnLoadingService,
    private readonly permissaoService: PermissaoService,
    private readonly bnUsuarioService: BnUsuarioService,
    private readonly datePipe: DatePipe,
    private readonly detalhesLeilaoService: DetalheLeilaoService,
    private readonly mensagemService: MensagemService
  ) {}

  ngOnInit(): void {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data["agentes"];
    this.setPermissaoUsuarioLogado();
    this.initForm();
    this.initPaginacao();

    this.estados = this.activatedRoute.snapshot.data["dominios"].estadosLeilao;
  }

  setPermissaoUsuarioLogado() {
    this.permissaoService
      .getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
        this.podeEnviarArquivo = resp && resp[ROLE_AGENTE_ENVIO];
        this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];

        this.bnUsuarioService.usuario$.subscribe((usuario) => {
          if (usuario && usuario.cnpj) {
            this.cnpjUsuario = usuario.cnpj;
            this.setAgenteFinanceiroLogado();
          }
        });
      });
  }

  initForm() {
    this.pesquisaForm = this.formBuilder.group({
      agenteFinanceiro: null,
      idLeilao: ["", [Validators.pattern(/^[0-9]+$/)]],
      idCobranca: ["", [Validators.pattern(/^[0-9]+$/)]],
      idProtocoloArquivo: [null],
      estado: null,
      idExternoOperacao: [
        "",
        [
          Validators.pattern(/^[A-Za-z0-9_\-]+$/),
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      sistema: null,
      contrato: [
        "",
        [
          Validators.pattern(/^[0-9]+$/),
          Validators.minLength(11),
          Validators.maxLength(11),
        ],
      ],
      dataEnvioInicio: null,
      dataEnvioFim: null,
    });
    this.setAgenteFinanceiro();
  }

  initPaginacao() {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined,
    };
  }

  setAgenteFinanceiro() {
    if (this.ehAgenteFinanceiro) {
      this.pesquisaForm
        .get("agenteFinanceiro")
        .setValue(this.agenteFinanceiroLogado);
      this.pesquisaForm.get("agenteFinanceiro").disable();
    }
  }

  limpar() {
    this.pesquisado = false;
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.reset({
        agenteFinanceiro: this.agentesFinanceiros.filter(
          (agente) => agente.cnpj === this.cnpjUsuario
        )[0],
      });
    } else {
      this.pesquisaForm.reset();
    }
    this.detalhesLeilao = [];
  }

  mudancaPagina(novaPagina: EntityPagedResult<DetalheLeilao>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  compararPorId(item1: string, item2: string): boolean {
    return item1 && item2 ? item1 === item2 : !item1 && !item2;
  }

  setAgenteFinanceiroLogado() {
    this.agenteFinanceiroLogado = this.agentesFinanceiros.find(
      (a) => a.cnpj === this.cnpjUsuario
    );
  }

  pesquisar() {
    this.buscar(false, false);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;
    const params: any = {};

    const agenteFinanceiro = this.pesquisaForm.get("agenteFinanceiro").value;
    if (agenteFinanceiro) {
      params.cnpjAgenteFinanceiro = agenteFinanceiro.cnpj;
    }

    const sistema = this.pesquisaForm.get("sistema").value;
    if (sistema) {
      params.sistema = sistema;
    }

    const idLeilao = this.pesquisaForm.get("idLeilao").value;
    if (idLeilao) {
      params.idLeilao = idLeilao.trim();
    }

    const idCobranca = this.pesquisaForm.get("idCobranca").value;
    if (idCobranca) {
      params.idCobranca = idCobranca.trim();
    }

    const idExternoOperacao = this.pesquisaForm.get("idExternoOperacao").value;
    if (idExternoOperacao && idExternoOperacao.trim()) {
      params.idExternoOperacao = idExternoOperacao.trim();
    }

    const dataEnvioInicio = this.pesquisaForm.get("dataEnvioInicio").value;
    if (dataEnvioInicio) {
      params.dataEnvioInicio = this.datePipe.transform(
        dataEnvioInicio,
        "yyyyMMdd"
      );
    }

    const dataEnvioFim = this.pesquisaForm.get("dataEnvioFim").value;
    if (dataEnvioFim) {
      params.dataEnvioFim = this.datePipe.transform(dataEnvioFim, "yyyyMMdd");
    }

    const contrato = this.pesquisaForm.get("contrato").value;
    if (contrato && contrato.trim()) {
      params.contrato = contrato.trim();
    }

    const estado: Estado = this.pesquisaForm.get("estado").value;
    if (estado) {
      params.idEstado = Number(estado.id);
    }

    const idProtocoloArquivo =
      this.pesquisaForm.get("idProtocoloArquivo").value;
    if (idProtocoloArquivo && idProtocoloArquivo.trim()) {
      params.idProtocoloArquivo = idProtocoloArquivo.trim();
    }
    this.loadingService.liberaTela();
    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));

    if (voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(
      this.detalhesLeilao,
      this.atributosPaginacaoComponenteListagem,
      this.totalObjetosRetornados
    );
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page =
        this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.detalhesLeilaoService
      .getDetalhesLeiloesPorFiltro(params)
      .subscribe((response) => {
        this.detalhesLeilao = response.resultados;
        this.pesquisado = true;
        this.esconderPesquisa = false
        this.atributosPaginacaoComponenteListagem.count = response
          ? response.totalRegistrosSemPaginacao
          : 0;
        this.atributosPaginacaoComponenteListagem.list = response.resultados;
        this.totalObjetosRetornados =
          this.atributosPaginacaoComponenteListagem.count;
        this.loadingService.liberaTela();
        paginaVazia = Utils.verificaPaginaVazia(
          this.detalhesLeilao,
          this.atributosPaginacaoComponenteListagem,
          this.totalObjetosRetornados
        );
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }
      });
  }
}
